import { positionManagementRoute } from '../route';
import { ARCHITECTURE_ID_SEARCH_PARAM } from '../search-param';

export const POSITION_SETUP_ROUTE_SEGMENT = 'setup';

const withArchitectureId = (pathname: string, architectureId: string): string =>
    `${pathname}?${new URLSearchParams({ [ARCHITECTURE_ID_SEARCH_PARAM]: architectureId }).toString()}`;

export const positionArchitectureUrl = (architectureId: string): string =>
    withArchitectureId(positionManagementRoute.patterns.positionManagement, architectureId);

export const positionSetupUrl = (architectureId: string): string =>
    withArchitectureId(
        `${positionManagementRoute.patterns.positionManagement}/${POSITION_SETUP_ROUTE_SEGMENT}`,
        architectureId,
    );
